import { render, staticRenderFns } from "./SalesByCustomer.vue?vue&type=template&id=4324a9ed&scoped=true"
import script from "./SalesByCustomer.vue?vue&type=script&lang=js"
export * from "./SalesByCustomer.vue?vue&type=script&lang=js"
import style0 from "./SalesByCustomer.vue?vue&type=style&index=0&id=4324a9ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324a9ed",
  null
  
)

export default component.exports